/**
 * @typedef {import('hast-util-sanitize').Schema} Options
 */

export {defaultSchema} from 'hast-util-sanitize'
export {default} from './lib/index.js'
